import CreatorPayment from './Payment.Creator';
import PaymentForm from './Payment.Form';
import MemberPayment from './Payment.Member';
import PaymentProcess from './Payment.Process';
import PaymentSuccess from './Payment.Success';

const Payment = () => {};

Payment.Form = PaymentForm;
Payment.Process = PaymentProcess;
Payment.Success = PaymentSuccess;
Payment.Creator = CreatorPayment;
Payment.Member = MemberPayment;

export default Payment;
